import styled from 'styled-components'
import { Chiclet } from 'sutra/components/Chiclet/Chiclet'
import { accents, gray, semantic } from 'sutra/tokens/colors'
import { radii } from 'sutra/tokens/radii'
import { spacing } from 'sutra/tokens/spacing'

export const CitationButton = styled.span`
  display: inline-flex;
  align-items: center;
  position: relative;
  color: ${gray[500]};
  border-radius: ${radii.sm}px;
  background: ${gray[100]};
  padding: 3px 6px;
  font-size: 8px;
  cursor: pointer;

  &:hover {
    background: ${gray[200]};
  }
`

export const ViewRecordLink = styled.a`
  color: ${accents.reflectionBlue[500]};
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  white-space: nowrap;

  &:hover {
    color: ${accents.reflectionBlue[600]};
    text-decoration: underline;
  }

  &:visited {
    color: ${accents.reflectionBlue[500]};
  }

  &:focus-visible {
    outline: 2px solid ${accents.reflectionBlue[500]};
    outline-offset: 2px;
  }
`

// Caps here (not on the popover body) so the header and footer stay pinned
// while CitationBody scrolls.
export const CitationContent = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 420px;
`

// Matches PopoverModal's Header exactly: title group + button row as two
// ordinary flex children, no reserved/calc'd padding — the toolbar is a
// real flex child now, not an overlay that needs clearance.
export const CitationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing[4]}px;
  padding: ${spacing[4]}px ${spacing[6]}px;
  border-bottom: 1px solid ${gray[200]};
  font-size: 14px;
  font-weight: 600;
  color: ${semantic.fg};
`

export const CitationHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]}px;
  min-width: 0;
  flex: 1;
`

export const CitationToolbar = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[1]}px;
  flex-shrink: 0;
`

// Same override as ModalTitleBar.tsx's ProductChiclet: lets the pill shrink
// and ellipsis-truncate instead of pushing the copy toolbar off the edge.
// $size="lg" already gives 14px, so no font-size override is needed here.
export const ProductChiclet = styled(Chiclet)`
  display: inline-block;
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const CitationBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: ${spacing[4]}px ${spacing[6]}px;
`

export const CitationFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: ${spacing[3]}px ${spacing[6]}px;
  border-top: 1px solid ${gray[200]};
  background: ${semantic.bg};
`

export const CitationLoading = styled.div`
  text-align: center;
  padding: ${spacing[5]}px;
`

export const CitationNotFound = styled.div`
  padding: ${spacing[2]}px;
  color: ${gray[500]};
`
